export const RestitutionType = {
    PARTIAL: 'PARTIAL',
    TOTAL: 'TOTAL',
    NO: 'NO',

    values: () => {
        return ['PARTIAL', 'TOTAL', 'NO'];
    }
}